import * as C from "../../../constants";

const initialState = {
  devices: [],
  cursor: "", // opaque next-page cursor from the API; empty on first page
  hasNext: false,
  limit: 100,
  refreshRecommended: false,
  newerCount: 0,
  isLoading: false,
  isFetchingMore: false,
  isAssigning: false,
  errorMessage: "",
};

export default function unassignedBatteries(state = initialState, action) {
  switch (action.type) {
    case C.UNASSIGNED_BATTERY_DEVICES_REQUEST:
      return { ...state, isLoading: true, errorMessage: "" };

    case C.UNASSIGNED_BATTERY_DEVICES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        devices: action.payload.devices || [],
        cursor: action.payload.next_cursor || "",
        hasNext: action.payload.has_next || false,
        refreshRecommended: action.payload.refresh_recommended || false,
        newerCount: action.payload.newer_count || 0,
      };

    case C.UNASSIGNED_BATTERY_DEVICES_FETCH_MORE_REQUEST:
      return { ...state, isFetchingMore: true };

    case C.UNASSIGNED_BATTERY_DEVICES_FETCH_MORE_SUCCESS:
      return {
        ...state,
        isFetchingMore: false,
        devices: [...state.devices, ...(action.payload.devices || [])],
        cursor: action.payload.next_cursor || "",
        hasNext: action.payload.has_next || false,
        refreshRecommended: action.payload.refresh_recommended || false,
        newerCount: action.payload.newer_count || 0,
      };

    case C.UNASSIGNED_BATTERY_DEVICES_FAILURE:
      return { ...state, isLoading: false, isFetchingMore: false, errorMessage: action.error };

    case C.ASSIGN_BATTERY_DEVICES_REQUEST:
      return { ...state, isAssigning: true, errorMessage: "" };

    case C.ASSIGN_BATTERY_DEVICES_SUCCESS:
      return { ...state, isAssigning: false };

    case C.ASSIGN_BATTERY_DEVICES_FAILURE:
      return { ...state, isAssigning: false, errorMessage: action.error };

    case C.UNASSIGNED_BATTERY_DEVICES_RESET:
      return initialState;

    default:
      return state;
  }
}
